import React, { useContext, useState } from "react";
import products from "../data/products";
import ProductCard from "../components/ProductCard";
import { SearchContext } from "../context/SearchContext";
import { CartContext } from "../context/CartContext";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import heroImg from "../assets/banner3.jpg";
import CottonShopbag from "../assets/CottonShoppingBag.jpg";
import Canvasbag from "../assets/CanvasShoppingBag.jpg";
import PromotionalBag from "../assets/PromotionalBag.jpg";
import JuteBag from "../assets/JuteBag.jpg";
import CustomDesigns from "../assets/JuteBagPromotional.jpg";

const Home = () => {
  const { search } = useContext(SearchContext);
  const { addToCart, addToWishlist } = useContext(CartContext);
  const navigate = useNavigate();

  // ✅ NEW STATE
  const [showAllCategories, setShowAllCategories] = useState(false);

  const filteredProducts = products.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  const isSearching = search.trim() !== "";

  return (
    <div className="home">

      {/* HERO */}
      <div className="hero">
        <img src={heroImg} alt="banner" />
        <div className="hero-overlay">
          <h1>Elegant Handmade Bags</h1>
          <p>Crafted with love & tradition</p>
          <button>Shop Now</button>
        </div>
      </div>

      {/* CATEGORY */}
      {!isSearching && (
        <div className="category-section">

          <div className="category-header">
            <h2>Shop by Category</h2>
            <span onClick={() => setShowAllCategories(!showAllCategories)}>
              {showAllCategories ? "Show Less" : "View All >"}
            </span>
          </div>

          <div className="category-wrapper">
            {/* ✅ UPDATED CLASS */}
            <div className={`category-list ${showAllCategories ? "expanded" : ""}`}>

              <div className="category-card" onClick={() => navigate("/category/clothbags")}>
                <div className="category-img-box">
                  <img src={CottonShopbag} alt="Cloth Bags" />
                </div>
                <p>Cloth Bags</p>
              </div>

              <div className="category-card" onClick={() => navigate("/category/canvasbags")}>
                <div className="category-img-box">
                  <img src={Canvasbag} alt="Canvas Bags" />
                </div>
                <p>Canvas Bags</p>
              </div>

              <div className="category-card" onClick={() => navigate("/category/promotionbags")}>
                <div className="category-img-box">
                  <img src={PromotionalBag} alt="Promotion Bags" />
                </div>
                <p>Promotion Bags</p>
              </div>

              <div className="category-card" onClick={() => navigate("/category/jutebag")}>
                <div className="category-img-box">
                  <img src={JuteBag} alt="Jute Bags" />
                </div>
                <p>Jute Bags</p>
              </div>

              <div className="category-card" onClick={() => navigate("/category/customisedbags")}>
                <div className="category-img-box">
                  <img src={CustomDesigns} alt="Custom Designs" />
                </div>
                <p>Custom Designs</p>
              </div>

            </div>
          </div>
        </div>
      )}

      {/* SEARCH */}
      {isSearching && (
        <>
          <h2 className="title">Search Results</h2>
          <div className="product-grid">
            {filteredProducts.length > 0 ? (
              filteredProducts.map((item) => (
                <ProductCard
                  key={item.id}
                  product={item}
                  addToCart={addToCart}
                  addToWishlist={addToWishlist}
                />
              ))
            ) : (
              <h3>No products found 😢</h3>
            )}
          </div>
        </>
      )}

      {/* PRODUCTS */}
      {!isSearching && (
        <>
          <h2 className="title">Our Handmade Collection</h2>
          <div className="product-grid">
            {products.map((item) => (
              <ProductCard
                key={item.id}
                product={item}
                addToCart={addToCart}
                addToWishlist={addToWishlist}
              />
            ))}
          </div>
        </>
      )}

      {/* REVIEW */}
      <div className="review-section">
        <div className="review-card">
          <p>"Great quality and fast delivery!"</p>
          <span>- Rajesh, Surat</span>
        </div>

        <div className="review-card">
          <p>"Perfect for corporate gifts!"</p>
          <span>- Priya, Mumbai</span>
        </div>
      </div>

    </div>
  );
};

export default Home;